export const defaultTableColorOptions = new Map([
    ['Status', [
        { name: 'Available', value: 'Available', severity: 'var(--color-green)' },
        { name: 'Occupied', value: 'Occupied', severity: 'var(--color-red)' }
    ]]
])

export const mergeTableColorOptions = (colorOptions) => {
    const mergedOptions = new Map(defaultTableColorOptions)

    colorOptions?.forEach((options, column) => {
        mergedOptions.set(column, options)
    })

    return mergedOptions
}
